import React, { useState } from "react";

const inputStyle = {
  border: "1.5px solid #e2e8f0",
  borderRadius: 8,
  padding: "10px 14px",
  fontSize: 14,
  color: "#1a202c",
  background: "#f8fafc",
  outline: "none",
  width: "100%",
  boxSizing: "border-box",
  fontFamily: "inherit",
};

const labelStyle = {
  fontWeight: 600,
  fontSize: 13,
  color: "#374151",
  marginBottom: 6,
  display: "block",
};

const errorStyle = { color: "#dc3545", fontSize: 12, marginTop: 4 };

// ── Indian states list ────────────────────────────────────────────────────────
const INDIAN_STATES = [
  "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa",
  "Gujarat","Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala",
  "Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland",
  "Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura",
  "Uttar Pradesh","Uttarakhand","West Bengal",
  "Andaman and Nicobar Islands","Chandigarh","Dadra and Nagar Haveli and Daman and Diu",
  "Delhi","Jammu and Kashmir","Ladakh","Lakshadweep","Puducherry",
];

// ── Cities by state (representative list — extend as needed) ─────────────────
const CITIES_BY_STATE = {
  "Andhra Pradesh": ["Visakhapatnam","Vijayawada","Guntur","Nellore","Kurnool","Tirupati","Kakinada","Rajahmundry"],
  "Arunachal Pradesh": ["Itanagar","Naharlagun","Pasighat"],
  "Assam": ["Guwahati","Silchar","Dibrugarh","Jorhat","Nagaon"],
  "Bihar": ["Patna","Gaya","Muzaffarpur","Bhagalpur","Darbhanga"],
  "Chhattisgarh": ["Raipur","Bhilai","Bilaspur","Korba","Durg"],
  "Goa": ["Panaji","Margao","Vasco da Gama","Mapusa"],
  "Gujarat": ["Ahmedabad","Surat","Vadodara","Rajkot","Bhavnagar","Jamnagar","Gandhinagar"],
  "Haryana": ["Faridabad","Gurgaon","Panipat","Ambala","Yamunanagar","Rohtak","Hisar"],
  "Himachal Pradesh": ["Shimla","Mandi","Solan","Dharamshala","Kangra"],
  "Jharkhand": ["Ranchi","Jamshedpur","Dhanbad","Bokaro","Deoghar"],
  "Karnataka": ["Bengaluru","Mysuru","Hubli","Mangaluru","Belagavi","Kalaburagi","Davangere"],
  "Kerala": ["Thiruvananthapuram","Kochi","Kozhikode","Thrissur","Kollam","Palakkad"],
  "Madhya Pradesh": ["Bhopal","Indore","Jabalpur","Gwalior","Ujjain","Sagar"],
  "Maharashtra": ["Mumbai","Pune","Nagpur","Nashik","Aurangabad","Solapur","Amravati","Kolhapur"],
  "Manipur": ["Imphal","Bishnupur","Thoubal"],
  "Meghalaya": ["Shillong","Tura","Jowai"],
  "Mizoram": ["Aizawl","Lunglei","Champhai"],
  "Nagaland": ["Kohima","Dimapur","Mokokchung"],
  "Odisha": ["Bhubaneswar","Cuttack","Rourkela","Berhampur","Sambalpur"],
  "Punjab": ["Ludhiana","Amritsar","Jalandhar","Patiala","Bathinda","Mohali"],
  "Rajasthan": ["Jaipur","Jodhpur","Kota","Bikaner","Udaipur","Ajmer","Alwar"],
  "Sikkim": ["Gangtok","Namchi","Gyalshing"],
  "Tamil Nadu": ["Chennai","Coimbatore","Madurai","Tiruchirappalli","Salem","Tirunelveli","Erode","Vellore"],
  "Telangana": ["Hyderabad","Warangal","Nizamabad","Karimnagar","Khammam"],
  "Tripura": ["Agartala","Dharmanagar","Udaipur"],
  "Uttar Pradesh": ["Lucknow","Kanpur","Agra","Varanasi","Meerut","Allahabad","Bareilly","Ghaziabad","Noida"],
  "Uttarakhand": ["Dehradun","Haridwar","Roorkee","Haldwani","Nainital"],
  "West Bengal": ["Kolkata","Asansol","Siliguri","Durgapur","Bardhaman","Howrah"],
  "Andaman and Nicobar Islands": ["Port Blair"],
  "Chandigarh": ["Chandigarh"],
  "Dadra and Nagar Haveli and Daman and Diu": ["Daman","Diu","Silvassa"],
  "Delhi": ["New Delhi","Delhi"],
  "Jammu and Kashmir": ["Srinagar","Jammu","Anantnag","Baramulla"],
  "Ladakh": ["Leh","Kargil"],
  "Lakshadweep": ["Kavaratti"],
  "Puducherry": ["Puducherry","Karaikal","Mahe","Yanam"],
};

const CommunicationDetails = ({
  employeeData,
  setEmployeeData,
  errors = {},
  setErrors,
  touchedFields = {},
  setTouchedFields,
  existingEmployees = [],
  currentUserInfoId = null,
}) => {
  const selectedState = employeeData.communicationDetails?.state || "";
  const cityOptions = selectedState ? (CITIES_BY_STATE[selectedState] || []) : [];
 

  const isDuplicateEmail = (email) => {
    const normalized = (email || "").trim().toLowerCase();
    if (!normalized) return false;
    return existingEmployees.some(
      (u) =>
        (u.email || "").trim().toLowerCase() === normalized &&
        u.userInfoId !== currentUserInfoId
    );
  };

 const handleAddressChange = (e) => {
    const value = e.target.value;
    setEmployeeData((prev) => ({
      ...prev,
      communicationDetails: { ...prev.communicationDetails, currentAddress: value },
    }));
    const t = value.trim();
    if (value === "") { setErrors((prev) => { const { currentAddress, ...r } = prev; return r; }); return; }
    if (t === "") { setErrors((prev) => ({ ...prev, currentAddress: "Address cannot contain only spaces" })); return; }
    if (/^[0-9]+$/.test(t)) { setErrors((prev) => ({ ...prev, currentAddress: "Address cannot contain only numbers" })); return; }
    if (/^[^a-zA-Z0-9]+$/.test(t)) { setErrors((prev) => ({ ...prev, currentAddress: "Address cannot contain only special characters" })); return; }
    if (!/[a-zA-Z]/.test(t)) { setErrors((prev) => ({ ...prev, currentAddress: "Address must contain at least one letter" })); return; }
    setErrors((prev) => { const { currentAddress, ...r } = prev; return r; });
  };
  const emailRegex = /^(?!\.)(?!.*\.\.)[A-Za-z0-9._%+-]+(?<!\.)@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmployeeData((prev) => ({
      ...prev,
      communicationDetails: { ...prev.communicationDetails, email: value },
    }));
    if (typeof setTouchedFields === "function") setTouchedFields((prev) => ({ ...prev, email: true }));
    const t = value.trim();
    if (value === "") { setErrors((prev) => ({ ...prev, email: "" })); return; }
    if (/\s/.test(value)) { setErrors((prev) => ({ ...prev, email: "Email cannot contain spaces" })); return; }
    if (!emailRegex.test(t)) { setErrors((prev) => ({ ...prev, email: "Enter a valid email address" })); return; }
    if (isDuplicateEmail(t)) { setErrors((prev) => ({ ...prev, email: "This email is already registered with another employee" })); return; }
    setErrors((prev) => { const { email, ...r } = prev; return r; });
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    setEmployeeData((prev) => ({
      ...prev,
      communicationDetails: { ...prev.communicationDetails, mobile: value },
    }));
    if (value === "") { setErrors((prev) => ({ ...prev, mobile: "" })); return; }
    if (/\s/.test(value)) { setErrors((prev) => ({ ...prev, mobile: "Mobile number cannot contain spaces" })); return; }
    if (!/^[0-9]+$/.test(value)) { setErrors((prev) => ({ ...prev, mobile: "Mobile number must contain only digits" })); return; }
    if (value.length < 10) { setErrors((prev) => ({ ...prev, mobile: "Mobile number must be exactly 10 digits" })); return; }
    if (value.length > 10) { setErrors((prev) => ({ ...prev, mobile: "Mobile number cannot exceed 10 digits" })); return; }
    setErrors((prev) => { const { mobile, ...r } = prev; return r; });
  };

  // ── FIX: State resets city when changed ──────────────────────────────────
  const handleStateChange = (e) => {
    const value = e.target.value;
    setEmployeeData((prev) => ({
      ...prev,
      communicationDetails: { ...prev.communicationDetails, state: value, city: "" },
    }));
    if (value) { setErrors((prev) => { const { state, ...r } = prev; return r; }); }
    else { setErrors((prev) => ({ ...prev, state: "State is required" })); }
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setEmployeeData((prev) => ({
      ...prev,
      communicationDetails: { ...prev.communicationDetails, city: value },
    }));
    if (value) { setErrors((prev) => { const { city, ...r } = prev; return r; }); }
    else { setErrors((prev) => ({ ...prev, city: "City is required" })); }
  };

  return (
    <>
      {/* ROW 1 — Email | Phone */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 18 }}>
        <div>
          <label style={labelStyle}>Email Address <span style={{ color: "#dc3545" }}>*</span></label>
          <input
            type="text"
            name="email"
            placeholder="email@company.com"
            value={employeeData.communicationDetails?.email || ""}
            onChange={handleEmailChange}
            style={{ ...inputStyle, borderColor: errors.email ? "#dc3545" : "#e2e8f0" }}
          />
          {errors.email && <div style={errorStyle}>{errors.email}</div>}
        </div>
        <div>
          <label style={labelStyle}>Phone Number <span style={{ color: "#dc3545" }}>*</span></label>
          <input
            type="text"
            name="mobile"
            placeholder="+91 XXXXXXXXXX"
            value={employeeData.communicationDetails?.mobile || ""}
            onChange={handleMobileChange}
            style={{ ...inputStyle, borderColor: errors.mobile ? "#dc3545" : "#e2e8f0" }}
          />
          {errors.mobile && <div style={errorStyle}>{errors.mobile}</div>}
        </div>
      </div>

      {/* ROW 2 — Address (full width textarea) */}
      <div style={{ marginBottom: 18 }}>
        <label style={labelStyle}>Address <span style={{ color: "#dc3545" }}>*</span></label>
        <textarea
          name="currentAddress"
          placeholder="Full address"
          value={employeeData.communicationDetails?.currentAddress || ""}
          onChange={handleAddressChange}
          rows={3}
          style={{
            ...inputStyle,
            resize: "vertical",
            borderColor: errors.currentAddress ? "#dc3545" : "#e2e8f0",
          }}
        />
        {errors.currentAddress && <div style={errorStyle}>{errors.currentAddress}</div>}
      </div>

      {/* ROW 3 — FIX: State LEFT, City RIGHT (city depends on state) */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 18 }}>

        {/* STATE — left column (select this first) */}
        <div>
          <label style={labelStyle}>State <span style={{ color: "#dc3545" }}>*</span></label>
          <select
            value={employeeData.communicationDetails?.state || ""}
            onChange={handleStateChange}
            style={{
              ...inputStyle,
              appearance: "auto",
              cursor: "pointer",
              borderColor: errors.state ? "#dc3545" : "#e2e8f0",
              color: employeeData.communicationDetails?.state ? "#1a202c" : "#9ca3af",
            }}
          >
            <option value="">Select State</option>
            {INDIAN_STATES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          {errors.state && <div style={errorStyle}>{errors.state}</div>}
        </div>

        {/* CITY — right column */}
<div>
  <label style={labelStyle}>City <span style={{ color: "#dc3545" }}>*</span></label>
  {
    // If no state selected but city exists from server (old data saved without state)
    // OR city is not in the dropdown → show free text input
    (!selectedState && employeeData.communicationDetails?.city) ||
    (selectedState && employeeData.communicationDetails?.city && !cityOptions.includes(employeeData.communicationDetails.city))
    ? (
      <input
        type="text"
        value={employeeData.communicationDetails?.city || ""}
        onChange={handleCityChange}
        style={{ ...inputStyle, borderColor: errors.city ? "#dc3545" : "#e2e8f0" }}
        placeholder="Enter city"
      />
    ) : (
      <select
        value={employeeData.communicationDetails?.city || ""}
        onChange={handleCityChange}
        disabled={!selectedState}
        style={{
          ...inputStyle,
          appearance: "auto",
          cursor: selectedState ? "pointer" : "not-allowed",
          borderColor: errors.city ? "#dc3545" : "#e2e8f0",
          color: employeeData.communicationDetails?.city ? "#1a202c" : "#9ca3af",
          opacity: selectedState ? 1 : 0.6,
        }}
      >
        <option value="">{selectedState ? "Select City" : "Select State first"}</option>
        {cityOptions.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
    )
  }
  {errors.city && <div style={errorStyle}>{errors.city}</div>}
</div>

      </div>
    </>
  );
};

export default CommunicationDetails;